import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BaseComponent } from '@app/directives/base-component';

@Component({
    selector: 'app-bank-account',
    templateUrl: './bank-account.component.html',
    styleUrls: ['./bank-account.component.scss'],
    standalone: false
})

export class BankAccountComponent extends BaseComponent implements OnInit {
  @Input() bank: any;
  @Input() defaultPaymentId: string;
  @Output() onUpdate: EventEmitter<any> = new EventEmitter();

  constructor() { super(); }

  ngOnInit(){
    // console.log(this.bank, this.defaultPaymentId)
  }
  onClickList(bank){
    this.onUpdate.next(bank)
  }
}